import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

interface AddItemData extends Types.IApi.AddItem.Request {
  collectionId: string;
}

const useAddItem = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ collectionId, ...data }: AddItemData) => {
      const response = await Api.addItem(collectionId, data);
      return response.data.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['collections', 'single', variables.collectionId] });
      queryClient.invalidateQueries({ queryKey: ['collections', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['collections', 'owned'] });
      if (variables.type === 'test') queryClient.invalidateQueries({ queryKey: ['test'] });
      toast.success('Item added', { description: 'Item has been added to the collection.' });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to add item',
      });
    },
  });
};

export default useAddItem;
